// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"77de553d","703":"c165c324"}[chunkId] + ".chunk.js";
};